import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { website } from "../assets/assets";
import { getStorageValue } from "../service/shared.service";

const DomainAllotmentModal = (props: any) => {
  const profile = getStorageValue("partnerProfile")[0]
  // console.log(props);
  const okay = () => {
    setTimeout(() => {
      window.location.reload();
    }, 200);
    props.onHide();
  }
  return (
    <div className="webflow">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          {/* <Modal.Title id="contained-modal-title-vcenter">
      
    </Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="text-center">
            <img className="mx-auto" src={website} alt="" />
            <h4>We're Crafting Your Website!</h4>
            <p>We will use this information to create your personalized website</p>
          </div>
          <div className="text-center">
            {/* <h4>Centered Modal</h4> */}
            <p className="w-75 mx-auto">
              Your Credee partner website will be live in just 15 minutes. We’re
              fine-tuning it for launch and will send an email to
              <Link className="text-dark fw-bolder text-decoration-none" to={`mailto:${profile.partner_email}`}> {profile.partner_email}  </Link>  as soon as it's ready.
            </p>
            <p className="w-75 mx-auto">
              Thank you for your patience. Get ready to engage and expand your network!
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="footer_Class text-center justify-content-center">
          <Button style={{ 'backgroundColor': '#007094 !important', 'padding': '10px 37px', 'fontSize': '18px' }} onClick={okay}>Okay</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default DomainAllotmentModal;